import { render, staticRenderFns } from "./BlackjackGame.vue?vue&type=template&id=3939b8c6&scoped=true"
import script from "./BlackjackGame.vue?vue&type=script&lang=js"
export * from "./BlackjackGame.vue?vue&type=script&lang=js"
import style0 from "./BlackjackGame.vue?vue&type=style&index=0&id=3939b8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3939b8c6",
  null
  
)

export default component.exports